(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diy-picture-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('diy-picture-comparison')) {
    customElements.define('diy-picture-comparison', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.range = this.querySelector('.sl2__range');
        if (!this.range) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const update = () => this.style.setProperty('--sl2-position', `${this.range.value}%`);
        const finish = () => {
          this.pointerId = null;
          this.removeAttribute('data-sl2-active');
        };
        const moveThumb = (event) => {
          if (event.pointerType !== 'mouse') return;
          const bounds = this.getBoundingClientRect();
          const y = Math.max(0, Math.min(bounds.height, event.clientY - bounds.top));
          this.style.setProperty('--sl2-thumb-y', `${y}px`);
        };
        this.range.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || event.button !== 0) return;
          this.pointerId = event.pointerId;
          moveThumb(event);
        }, options);
        this.range.addEventListener('pointermove', (event) => {
          if (event.pointerId === this.pointerId) moveThumb(event);
        }, options);
        this.range.addEventListener('input', () => {
          update();
          this.setAttribute('data-sl2-active', '');
        }, options);
        this.range.addEventListener('change', () => {
          update();
          finish();
        }, options);
        this.range.addEventListener('blur', finish, options);
        this.range.addEventListener('keyup', finish, options);
        this.range.addEventListener('pointercancel', finish, options);
        this.range.addEventListener('lostpointercapture', finish, options);
        window.addEventListener('pointerup', (event) => {
          if (event.pointerId === this.pointerId) finish();
        }, options);
        window.addEventListener('blur', finish, options);
        update();
        if (!this.hasAttribute('data-sl2-reveal') && 'IntersectionObserver' in window && !window.Shopify?.designMode) {
          this.setAttribute('data-sl2-reveal', 'pending');
          this.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              this.setAttribute('data-sl2-reveal', 'shown');
              this.observer.disconnect();
            }
          }, { threshold: 0 });
          this.observer.observe(this);
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        if (this.getAttribute('data-sl2-reveal') === 'pending') this.removeAttribute('data-sl2-reveal');
        this.pointerId = null;
        this.removeAttribute('data-sl2-active');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
